




















import { Component, Vue } from 'vue-property-decorator';
import { FormFilePlugin } from 'bootstrap-vue';
import { audioCtx } from '@/audioGlobal';
import Oscilloscope from '@/components/oscilloscope.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(FormFilePlugin);

@Component({
    components: { Oscilloscope }
})
export default class Play extends Vue {
    private audioNode?: AudioNode = new OscillatorNode(audioCtx); // export to oscilloscope.vue
    private audioEle?: HTMLAudioElement;
    private isPlaying = false;

    $refs!: {
        audioController: HTMLAudioElement;
    };

    mounted() {
        this.audioEle = this.$refs.audioController;
        this.audioEle.src = 'music/default.mp3';
        this.audioNode = audioCtx.createMediaElementSource(this.audioEle);
    }

    private loadFile(event: InputEvent) {
        const InputEle = event.target as HTMLInputElement;
        if (InputEle.files) {
            this.pause();
            (this.audioEle as HTMLAudioElement).src = URL.createObjectURL(
                InputEle.files[0]
            );
        }
    }

    private play() {
        this.isPlaying = true;
    }

    private pause() {
        this.isPlaying = false;
    }
}
